"use strict";
/**
 * Created on 10 24 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WindowItemSitesData_1 = require("../model/WindowItemSitesData");

var WindowItemSitesDataConverter_1 = require("./WindowItemSitesDataConverter");
/**
 * Implementation of {@link WindowItemSitesDataConverter}.
 *
 * @author JMe
 */


var WindowItemSitesDataConverterImpl =
/*#__PURE__*/
function (_WindowItemSitesDataC) {
  _inherits(WindowItemSitesDataConverterImpl, _WindowItemSitesDataC);

  function WindowItemSitesDataConverterImpl() {
    _classCallCheck(this, WindowItemSitesDataConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemSitesDataConverterImpl).apply(this, arguments));
  }

  _createClass(WindowItemSitesDataConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        sites: conversions.asObjectArray(source, 'sites', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        delisted: source.delisted,
        notListedInEverySite: source.notListedInEverySite
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new WindowItemSitesData_1.WindowItemSitesData(WindowItemSitesData_1.WindowItemSitesData.schema.sites.valueOf(conversions.asClassReferenceIdsSet(source, 'sites')), WindowItemSitesData_1.WindowItemSitesData.schema.delisted.valueOfField(source), WindowItemSitesData_1.WindowItemSitesData.schema.notListedInEverySite.valueOfField(source));
    }
  }]);

  return WindowItemSitesDataConverterImpl;
}(WindowItemSitesDataConverter_1.WindowItemSitesDataConverter);

exports.WindowItemSitesDataConverterImpl = WindowItemSitesDataConverterImpl;